<template>
  <div class="flex flex-col gap-1">
    <SelectButton v-model="rating" :options="options" optionLabel="label" optionValue="value"
      :allowEmpty="true" :data-testid="`feedback-rating-${String(item.id ?? '')}`" class="flex-wrap" />
    <small class="text-surface-500">{{ summary || 'Not rated yet' }}</small>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatRating, ratingOptions } from '@/utils/resultFeedbackRating';

/**
 * Rating control for a report-card trait whose feedback item is a RATING
 * (#574 phase 4). The report-card templates hold feedback rows as loosely
 * typed records, so the props accept any object and narrow here.
 */
const props = defineProps<{ feedback: object }>();
const model = defineModel<unknown>();

const item = computed(() => props.feedback as Record<string, unknown>);

const rating = computed({
  get: () => (typeof model.value === 'number' ? model.value : null),
  set: (v: number | null | undefined) => { model.value = v ?? null; },
});

const ratingMax = computed(() => (typeof item.value.rating_max === 'number' ? item.value.rating_max : null));

const options = computed(() => ratingOptions({
  rating_max: ratingMax.value,
  rating_scale_labels: Array.isArray(item.value.rating_scale_labels)
    ? item.value.rating_scale_labels.map(String)
    : undefined,
}));

const summary = computed(() => formatRating(
  options.value.find(o => o.value === rating.value)?.label,
  rating.value,
  ratingMax.value,
));
</script>
